export const NavigationActions = {
    INIT_NAVIGATION: 'INIT_NAVIGATION',
    NAVIGATE_TO: 'NAVIGATE_TO',
    NAVIGATE_TO_INIT_DEEP_LINK: 'NAVIGATE_TO_INIT_DEEP_LINK',
    DISPLAY_SHARE_DEAL_MODAL: 'DISPLAY_SHARE_DEAL_MODAL',
    UPDATE_HEADER_POSITION: 'UPDATE_HEADER_POSITION',
    SHOW_DEALER_DEAL_MODAL: 'SHOW_DEALER_DEAL_MODAL',
    SHOW_ASK_A_QUESTION_MODAL: 'SHOW_ASK_A_QUESTION_MODAL',
    SHOW_ACCEPT_DEAL_MODAL: 'SHOW_ACCEPT_DEAL_MODAL'
};
